import { List } from "models/list";
import { doGet, doPost, parseListPath } from "../request";
import { ListEmailTemplate } from "models/list-email-template";

export const adminDoGetListEmailTemplates = async (list: List) => {
  const emailTemplates = await doGet<ListEmailTemplate[]>(
    parseListPath(list, "email-templates"),
  );
  return emailTemplates;
};

export const adminDoPostListEmailTemplate = async (
  list: List,
  type: string,
  data: Partial<ListEmailTemplate>,
) => {
  const emailTemplate = await doPost<ListEmailTemplate>(
    parseListPath(list, `email-template/${type}`),
    data,
  );
  return emailTemplate;
};
